import PropTypes from 'prop-types';
import { isComplete, isLoading, isError } from '../readyState';
import { prepareNameProp } from './helpers';
import get from 'lodash/get';
import uniq from 'lodash/uniq';
import compact from 'lodash/compact';
import groupBy from 'lodash/groupBy';
import chunk from 'lodash/chunk';

export const stateParamName = 'offices';
export const stateListParamName = 'list';

export const PROP_ID = 'id';
export const PROP_COUNTRY = 'comment';
export const PROP_CITY = 'city';
export const PROP_ADDRESS = 'address';

export const getListItemShape = () => PropTypes.shape({
  [PROP_ID]: PropTypes.number,
  [PROP_COUNTRY]: PropTypes.string,
  [PROP_CITY]: PropTypes.string,
  [PROP_ADDRESS]: PropTypes.string,
});

export const getState = (globalState) => get(globalState, stateParamName, null);

export const getOffices = (globalState) => {
  const state = getState(globalState);
  return get(state, stateListParamName, []);
};

export const isOfficesLoaded = (globalState) => {
  const state = getState(globalState);
  return isComplete(state);
};

export const isOfficesLoading = (globalState) => {
  const state = getState(globalState);
  return isLoading(state);
};

export const isOfficesLoadError = (globalState) => {
  const state = getState(globalState);
  return isError(state);
};

export const prepareOfficesList = (offices = []) => (
  offices.map((office) => ({
    ...office,
    [PROP_CITY]: office[PROP_CITY] ? prepareNameProp(office[PROP_CITY]) : '',
    [PROP_COUNTRY]: office[PROP_COUNTRY] ? prepareNameProp(office[PROP_COUNTRY]) : ''
  }))
);

export const filterByCountry = (items = [], country) => (
  items.filter((item) => item[PROP_COUNTRY] === country)
);

export const filterByCity = (items = [], city) => (
  items.filter((item) => item[PROP_CITY] === city)
);

export const extractCountries = (items = [], baseCountry) => {
  const countries = items.map(item => item[PROP_COUNTRY]);
  const uniqCountries = uniq(compact(countries));
  const sortedCountries = uniqCountries.sort();

  if (!baseCountry || !sortedCountries.includes(baseCountry)) {
    return sortedCountries;
  }

  return [
    baseCountry,
    ...sortedCountries.filter((country) => country !== baseCountry)
  ];
};

export const extractCities = (offices) => {
  const cities = offices.map((office) => office[PROP_CITY]);
  return uniq(compact(cities)).sort();
};

export const groupByFirstLetter = (cities) => groupBy(cities, (city) => city[0]);

export const groupFirstLettersInRows = (cities, rowItemsCount = 4) => {
  const firstLetters = uniq(cities.map(city => city[0]));
  return chunk(firstLetters, rowItemsCount);
};

export const getCityByOfficeId = (offices, officeId) => {
  if (!officeId) {
    return null;
  }
  const office = offices.find((item) => item[PROP_ID] === officeId);
  return office ? office[PROP_CITY] : null;
};

export const getCountryByOfficeId = (offices, officeId) => {
  if (!officeId) {
    return null;
  }
  const office = offices.find((item) => item[PROP_ID] === officeId);
  return office ? office[PROP_COUNTRY] : null;
};
